import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  Rules,
  RulesContext,
  getSVGViewBox
} from '../assets';

@Component({
  selector: 'kyc-icon-rules',
  template: Rules.svg,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RulesComponent implements SVG2TSDynamic, OnInit {
  public static UUID = 0;
  public baseUrl: string;
  @Input() public height: number | string = Rules.height;
  @Input() public viewBox: string = getSVGViewBox(Rules.viewBox);
  @Input() public width: number | string = Rules.width;
  @Input()
  public set context(ctx: RulesContext) {
    this.updateContext(ctx);
  }
  public get context() {
    return this._context;
  }

  private _context: RulesContext = Rules.contextDefaults;

  constructor(private _ref: ChangeDetectorRef) {}


  public getURLBase(value: string) {
    return `url('${this.getXlinkBase(value)}')`;
  }

  public getXlinkBase(value: string) {
    return `${this.baseUrl}${value}`;
  }

  public ngOnInit() {
    this.baseUrl = window.location.href.replace(window.location.hash, '');
    this.context.uuid = RulesComponent.UUID++;
  }

  public updateContext(ctx: any) {
    this._context = Object.assign({}, this._context ? this._context : Rules.contextDefaults, ctx);
    this._ref.markForCheck();
  }
}
